import { useEffect, useState } from "react";

import { api, type AppConfig } from "../api/client";

let cached: AppConfig | null = null;

/** `/config` for brand name and colours; applies colours as CSS variables (06 §3). */
export function useConfig(): AppConfig | null {
  const [config, setConfig] = useState<AppConfig | null>(cached);

  useEffect(() => {
    if (cached) return;
    let cancelled = false;
    api<AppConfig>("/config", { auth: false, query: { platform: "web" } })
      .then(({ data }) => {
        cached = data;
        applyColors(data.colors);
        document.title = `${data.app_name} Admin`;
        if (!cancelled) setConfig(data);
      })
      .catch(() => {
        /* keep compiled defaults */
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return config;
}

function applyColors(colors: Record<string, string>) {
  const root = document.documentElement;
  for (const [key, value] of Object.entries(colors)) {
    if (/^#[0-9a-f]{6,8}$/i.test(value)) root.style.setProperty(`--c-${key.replace(/_/g, "-")}`, value);
  }
}
